import { svg } from 'lit';
export const alert24Svg = svg `
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <g clip-path="url(#clip0_6716_5814)">
    <path d="M7.653 1.5H16.347L22.5 7.653V16.347L16.347 22.5H7.653L1.5 16.347V7.653L7.653 1.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 7.5V12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 16.5H12.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_6716_5814">
      <rect width="24" height="24" fill="white"/>
    </clipPath>
  </defs>
</svg>
`;
//# sourceMappingURL=alert_24.svg.js.map